// Les sons d'Arceau Game (D-161 : « le dé roule avec un son ») : synthétisés (Web Audio, aucun fichier), sur le contexte
// audio du moteur plein écran des drills (drill-engine.ts : débloqué au premier toucher, Safari iOS compris).
import { unlockAudio } from './drill-engine';

let on = true;
export const setGameSound = (v: boolean) => { on = v; };

function ctx(): AudioContext | null { if (!on) return null; const a = unlockAudio(); if (a && a.state === 'suspended') void a.resume(); return a; }
function tone(a: AudioContext, t: number, f: number, dur: number, type: OscillatorType = 'sine', gain = 0.25, to?: number) {
  const o = a.createOscillator(), g = a.createGain();
  o.type = type; o.frequency.setValueAtTime(f, t);
  if (to) o.frequency.exponentialRampToValueAtTime(to, t + dur);
  g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(gain, t + 0.01); g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.connect(g); g.connect(a.destination); o.start(t); o.stop(t + dur + 0.02);
}
function noise(a: AudioContext, t: number, dur: number, freq: number, gain = 0.35, q = 1.2) {
  const n = Math.max(1, Math.floor(a.sampleRate * dur));
  const buf = a.createBuffer(1, n, a.sampleRate), d = buf.getChannelData(0);
  for (let i = 0; i < n; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / n);
  const s = a.createBufferSource(), f = a.createBiquadFilter(), g = a.createGain();
  s.buffer = buf; f.type = 'bandpass'; f.frequency.value = freq; f.Q.value = q;
  g.gain.setValueAtTime(gain, t); g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  s.connect(f); f.connect(g); g.connect(a.destination); s.start(t); s.stop(t + dur + 0.02);
}

/** Le dé qui roule : des chocs de plus en plus espacés, puis il se pose. */
export function sndRoll(): void {
  try {
    const a = ctx(); if (!a) return;
    let t = a.currentTime, gap = 0.045;
    for (let i = 0; i < 11; i++) { noise(a, t, 0.05, 1800 + Math.random() * 1600, 0.4, 3); t += gap; gap *= 1.2; }
    noise(a, t + 0.02, 0.12, 420, 0.6, 1); tone(a, t + 0.02, 150, 0.12, 'sine', 0.3);
  } catch { /* sans son */ }
}
/** Un pas du pion : un « tok » qui monte case après case. */
export function sndStep(i: number, back = false): void {
  try { const a = ctx(); if (!a) return; tone(a, a.currentTime, back ? 520 - i * 25 : 480 + i * 45, 0.09, 'triangle', 0.28); } catch { /* sans son */ }
}
/** La carte qui se retourne : un souffle. */
export function sndFlip(): void {
  try {
    const a = ctx(); if (!a) return;
    const t = a.currentTime;
    noise(a, t, 0.28, 900, 0.25, 0.7); noise(a, t + 0.12, 0.2, 2400, 0.15, 0.9);
    tone(a, t + 0.3, 1320, 0.25, 'sine', 0.12); tone(a, t + 0.36, 1760, 0.3, 'sine', 0.1);
  } catch { /* sans son */ }
}
/** « Fait ! » : deux notes qui montent. */
export function sndOk(): void {
  try { const a = ctx(); if (!a) return; const t = a.currentTime; tone(a, t, 660, 0.14, 'triangle', 0.3); tone(a, t + 0.11, 990, 0.22, 'triangle', 0.3); } catch { /* sans son */ }
}
/** « Raté » : une note qui descend. */
export function sndKo(): void {
  try { const a = ctx(); if (!a) return; const t = a.currentTime; tone(a, t, 330, 0.35, 'sawtooth', 0.12, 140); } catch { /* sans son */ }
}
/** Une case d'action : un petit arpège. */
export function sndBonus(): void {
  try { const a = ctx(); if (!a) return; const t = a.currentTime; [523, 659, 784, 1047].forEach((f, i) => tone(a, t + i * 0.07, f, 0.16, 'square', 0.09)); } catch { /* sans son */ }
}
/** L'arrivée : une fanfare, puis un accord. */
export function sndFanfare(): void {
  try {
    const a = ctx(); if (!a) return;
    const t = a.currentTime;
    [[523, 0], [659, 0.14], [784, 0.28], [1047, 0.42]].forEach(([f, d]) => tone(a, t + d!, f!, 0.2, 'square', 0.12));
    for (const f of [523, 659, 784, 1047]) tone(a, t + 0.62, f, 1.3, 'triangle', 0.12);
    for (let i = 0; i < 6; i++) noise(a, t + 0.62 + i * 0.09, 0.08, 5000, 0.08, 2);
  } catch { /* sans son */ }
}
